import React from "react";
import Icon from "../../assets/icons/Icon";

const FavouriteStar = ({ isFavourite, handleClick }) => {
  return (
    <div className="p-0 market-fav" onClick={handleClick}>
      <Icon
        name={isFavourite ? "FaStar" : "FaRegStar"}
        // name="FaStar"
        size="15"
        className={`${isFavourite ? "active" : ""}  fav-star`}
      />
    </div>
  );
};

export default FavouriteStar;
